/**
 * Product catalog for scoutspals.ca
 * Official web applications for UpDog Challenge event management, field scoring & live results.
 */
export const products = [
  {
    id: "scoring",
    title: "UpDog Field Scorer",
    tagline: "Official round timers & rapid field point entry for judges.",
    description: "Built specifically for UpDog field judges and line volunteers. Features specialized scoring interfaces and synchronized countdown timers for UpDog games (Throw & Go, 4WayPlay, Frizgility, FunKey, FarOut, and more). Touch-optimized with instant point calculation and cloud sync.",
    category: "Field Scoring",
    status: "Live",
    featured: true,
    url: "https://app.scoutspals.ca/",
    guideUrl: "./guide.html#4-live-field-scoring-console",
    guideLabel: "Scorer Guide",
    technologies: ["UpDog Games", "Field Timer", "Touch UI", "Instant Sync"],
    bannerGradient: "linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 50%, #A7F3D0 100%)",
    accentColor: "#10B981",
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2 2"/><path d="M5 3L2 6"/><path d="M22 6l-3-3"/><path d="M12 2v3"/></svg>`
  },
  {
    id: "admin",
    title: "UpDog Event Admin",
    tagline: "Event setup, running orders & verified scoresheet management.",
    description: "The central command center for UpDog club directors and scorekeepers. Configure games, manage handler/dog rosters and level designations, organize live running orders, and audit scoresheets ready for official UpDog submission.",
    category: "Club Admin",
    status: "Live",
    featured: true,
    url: "https://scoresheet.scoutspals.ca/",
    guideUrl: "./guide.html#2-event-setup--global-configuration",
    guideLabel: "Admin Guide",
    technologies: ["Event Director", "Roster Control", "Score Auditing", "UpDog Submission"],
    bannerGradient: "linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 50%, #C7D2FE 100%)",
    accentColor: "#6366F1",
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/><path d="M9 14l2 2 4-4"/></svg>`
  },
  {
    id: "results",
    title: "UpDog Live Results",
    tagline: "Real-time tournament standings, game breakdowns & team stats.",
    description: "Public leaderboard portal for handlers and spectators. View live division standings, round-by-round points, and podium placements updated in real time as judges log scores on the field.",
    category: "Leaderboards",
    status: "Live",
    featured: true,
    url: "https://results.scoutspals.ca/",
    guideUrl: "./guide.html#6-viewing-results--leaderboards",
    guideLabel: "Leaderboard Guide",
    technologies: ["Live Standings", "Game Breakdowns", "Handler Stats", "Mobile Friendly"],
    bannerGradient: "linear-gradient(135deg, #FFFBEB 0%, #FEF3C7 50%, #FDE68A 100%)",
    accentColor: "#F59E0B",
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.45 1-1 1H7c-.55 0-1 .45-1 1v1h12v-1c0-.55-.45-1-1-1h-2c-.55 0-1-.45-1-1v-2.34"/><path d="M6 4h12v7a6 6 0 0 1-12 0V4z"/></svg>`
  }
];
